// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-link[data-v-bb631b3c]:hover{text-decoration:underline}.label[data-v-bb631b3c]{font-size:14px;font-size:.875rem}.description[data-v-bb631b3c]{font-size:12px;font-size:.75rem}.outline[data-v-bb631b3c]{border:1px solid #e9ecef}", ""]);
// Exports
module.exports = exports;
